import ru from './ru';
import mn from './mn';
import es from './es';

export default {
  ru,
  mn,
  es,
};
